import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  position: relative;
  z-index: 2;
  flex: 1 1 0;
  min-width: 0;
  white-space: nowrap;

  margin-bottom: ${p => p.marginBottom || 0};

  ${p => p.size === "sm" && "font-size: 1rem"};
  ${p => p.size === "md" && "font-size: 2rem"};
  ${p => p.size === "lg" && "font-size: 3rem"};

  ${p => p.isUppercase && "text-transform: uppercase"};

  line-height: 1;
  font-weight: ${p => p.isBold ? p.theme.fontWeightBold : p.theme.fontWeightSemibold};

  color: ${p => p.isSuccess ? p.theme.colorSuccess : p.isLabel ? p.theme.colorTicketLabel : p.theme.colorTicketText};
`;

const Wrapper = ({
  children,
  isSuccess,
  isLabel,
  isUppercase,
  isBold,
  size,
  marginBottom
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    isSuccess: isSuccess,
    isLabel: isLabel,
    isUppercase: isUppercase,
    isBold: isBold,
    size: size,
    marginBottom: marginBottom
  }, children);
};

export default Wrapper;